module.exports = __webpack_public_path__ + "img/address_background@2x.28533557.png";